import { RecaptchaVerifier } from 'firebase/auth';
import { auth } from '~/firebase/init';
import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import useAuth from '~/hooks/useAuth';

type AuthProviderProps = {
  children: React.ReactElement | null;
};

export default function AuthProvider({ children }: AuthProviderProps) {
  useAuth();
  useEffect(() => {
    window.recaptchaVerifier = new RecaptchaVerifier(
      'recaptcha-container',
      {
        size: 'invisible',
        callback: () => {
          console.log('allow');
        },
        'expired-callback': () => {
          console.log('resolve again');
        },
      },
      auth,
    );
  }, []);

  return (
    <>
      <Box display="none" id="recaptcha-container" />
      {children}
    </>
  );
}
